<template>
  <div id="instrument-addition">
    <account type="新增商品" ></account>
  </div>
</template>

<script>
import AccountComponent from '@/components/instrument/AccountComponent.vue'
export default {
  name: 'instrument-addition',
  components: {
    'account': AccountComponent
  },
  data() {
    return {
      
    }
  },
  mounted(){
    
  },
  methods: {
    
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-addition{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Addition.vue